import { useState } from 'react';
import CreateCreditNoteHeader from './createCrediNoteHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import CreditNoteForm from './creditNoteForm';
import CreditNoteTable from './creditNoteTable';

const SalesCreateCreditNote = () => {
	const [error, setError] = useState({});
	const [creditNote, setCreditNote] = useState({
		customer_id: null,
		credit_note_number: null,
		date: getCurrentDate(),
		credit_note_type: 1,
		amount_paid: '',
		reference: '',
		notes: '',
	});
	const [salesReturnNumbers, setSalesReturnNumbers] = useState([]);
	const [creditNoteTable, setCreditNoteTable] = useState([]);
	const calculateTotalPayment = () => {
		if (creditNote?.credit_note_type === 1) {
			return creditNoteTable?.reduce((total, bill) => Number(total) + Number(bill.amount), 0);
		} else {
			return creditNoteTable?.reduce(
				(total, bill) => Number(total) + Number(bill.excess_payment_amount),
				0,
			);
		}
	};

	const handleDeleteRow = (id) => {
		setCreditNoteTable((prevArray) => prevArray.filter((item) => item.id !== id));
		setSalesReturnNumbers((prevArray) => prevArray.filter((item) => item.id !== id));
	};

	return (
		<div className="w-100">
			<CreateCreditNoteHeader
				error={error}
				setError={setError}
				creditNote={creditNote}
				salesReturnNumbers={salesReturnNumbers}
				creditNoteTable={creditNoteTable}
				totalAmount={calculateTotalPayment}
			/>
			<CreditNoteForm
				creditNote={creditNote}
				setSalesReturnNumbers={setSalesReturnNumbers}
				salesReturnNumbers={salesReturnNumbers}
				setCreditNote={setCreditNote}
				error={error}
				setError={setError}
				setCreditNoteTable={setCreditNoteTable}
				creditNoteTable={creditNoteTable}
			/>
			{creditNote.credit_note_type !== 3 && (
				<CreditNoteTable
					column={
						creditNote.credit_note_type === 1
							? ['Date Created', 'Sales Return Number', 'Amount', 'Actions']
							: ['Invoice#', 'PR#', 'Total Amount', 'Excess Amount']
					}
					rows={creditNoteTable}
					creditNoteType={creditNote.credit_note_type}
					handleDelete={(id) => {
						if (creditNote.credit_note_type === 1) {
							handleDeleteRow(id);
						}
					}}
				/>
			)}
			<div className="credit-summary-container">
				<div className="credit-summary-bar">
					<div className="d-flex align-items-center justify-content-end h-100 px-4">
						<p className="credit-summary-text mb-0 w-100">
							Credit Total: ₹
							{creditNote?.credit_note_type !== 3
								? calculateTotalPayment().toFixed(2)
								: creditNote?.amount_paid}
							/-
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
export default SalesCreateCreditNote;
